import { Route, Routes, useNavigate, } from "react-router-dom";
import logo from './logo.svg';
import './App.css';
import Login from "./screens/Login";
import { useDispatch, useSelector } from "react-redux";
import { useContext, useEffect } from "react";
import Actions from "./redux/actions";
import API from "./api/api";
import { Col, Row, Toast, ToastContainer } from "react-bootstrap";
import SideBarNav from "./components/Sidebar";
import Dashboard from "./screens/Dashboard";
import Settings from "./screens/Settings";
import Access from "./screens/Access";
import Suggestions from "./screens/Suggestions";
import User from "./screens/User";
import Signup from "./screens/Signup";
import ForgotPass from "./screens/ForgotPass";
import TopBarNav from "./components/Topbar";
import $ from 'jquery'
import Affiliate from "./screens/Affiliate";
import BlockedEmail from "./screens/BlockedEmails";
import BlockedEmailViewer from "./screens/BlockedEmailViewer";
import PhishingUrls from "./screens/PhishingUrls";
import PhishingUrlsViewer from "./screens/PhishingUrlsViewer";
function App() {

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const DEVICE_WIDTH = window.innerWidth

  const showToast = useSelector(state => state.showToast)
  const toastHeader = useSelector(state => state.toastHeader)
  const toastMsg = useSelector(state => state.toastMsg)

  const user = useSelector(state => state.user)
  useEffect(() => {
    _checkForUser()


  }, [])

  const _handleMsg = (msg) => {
    console.log(msg)
  }

  const _checkForUser = async () => {
    const token = localStorage.getItem('refreshToken')
    console.log(token)
    if (token) {
      try {


        const res = await API.getUser()
        if (res.isError && !window.location.href.includes('signup')) {
          localStorage.removeItem('jwt')
          localStorage.removeItem('refreshToken')
          navigate('/login', { replace: true })
          return
        }
        const accounts = await API.getSubAccounts()
        const stats = await API.getStats()
        const filenames = await API.getFileNames()

        dispatch(Actions.setFileNames(filenames))
        dispatch(Actions.setStats(stats.stats))
        dispatch(Actions.setUser(res.user))
        dispatch(Actions.setAccounts(accounts))
        if (window.location.href.includes('login')) {
          navigate('/')
        }
      } catch (e) {

      }
    } else {

      if (!window.location.href.includes('signup') && !window.location.href.includes('passwordreset') && !window.location.href.includes('reset') && !window.location.href.includes('scan')) {
        navigate('/login', { replace: true })

      }
    }
  }

  return (
    <div className="App">

      {DEVICE_WIDTH > 1024 ? <Row className='m-0'>

        {user && !window.location.href.includes('signup') && <Col md={2} className='m-0 p-0'>
          <SideBarNav />
        </Col>}
        <Col md={user && !window.location.href.includes('signup') ? 10 : 12} className='vh-100 m-0 p-0' style={{ overflowY: 'scroll', }}>
          <Router />
        </Col>
      </Row> : <>
        {user && !window.location.href.includes('signup') && <TopBarNav />}
        <Router />

      </>}
      <ToastContainer position="bottom-end" className="p-3">
        <Toast onClose={() => dispatch(Actions.clearToast())} show={showToast} delay={4000} autohide>
          <Toast.Header>
            <strong className='me-auto'>{toastHeader}</strong>
          </Toast.Header>
          <Toast.Body>{toastMsg}</Toast.Body>
        </Toast>
      </ToastContainer>
    </div>
  );
}





function Router() {
  const user = useSelector(state => state.user)

  return (
    <Routes>
      <Route path="/login" exact element={<Login />} />
      <Route path="/signup" exact element={<Signup />} />

      <Route path="/" exact element={<Dashboard />} />
      <Route path="/settings" element={<Settings />} />
      <Route path="/access" element={<Access />} />
      <Route path="/user" element={<User />} />
      <Route path="/suggestion" element={<Suggestions />} />
      <Route path="/passwordreset" element={<ForgotPass />} />
      <Route path="/email" element={<BlockedEmail />} />
      <Route path='/email/:id' element={<BlockedEmailViewer />} />
      <Route path="/affiliate" element={<Affiliate />} />
      <Route path="/phishing" element={<PhishingUrls />} />
      <Route path="/phishing/:id" element={<PhishingUrlsViewer />} />

    </Routes>
  )
}
export default App;
